export const FlagIcon = require ('./icons/flag.png').default